import { Prefill } from '@library/formBuilder/prefill';
import type { AtomModel } from '@models/atom.model';
import type { CommentFieldData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<CommentFieldData>;
};

export const CommentModal = ({ atom }: Props) => (
  <>
    <Prefill atom={atom} />
  </>
);
